module.exports = __webpack_public_path__ + "img/fs_siji.4a5dc565.png";